<template>
  <div>
    <SiteHeader bg="false"></SiteHeader>
    <EULA />
    <SiteFooter></SiteFooter>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue';
import EULA from '@/components/Eula.vue';
import SiteFooter from '@/components/Footer.vue';
export default {
  name: 'Home',
  components: {
    SiteHeader,
    SiteFooter,
    EULA
  },
  props: []
};
</script>

<style lang="scss"></style>
